import { Pencil, Trash2 } from 'lucide-react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import type { RowAction } from '@nucleus-commerce/admin-kit/index-table';
import type { TaxRate } from '@nucleus-commerce/api-client/admin';

export type TaxRateAction = 'edit' | 'delete';

/** Edit and delete; the page offers them only with `settings.write`. */
export function useTaxRateRowActions(onAction: (action: TaxRateAction, rate: TaxRate) => void) {
  const { t } = useTranslation('tax');
  return useMemo<Array<RowAction<TaxRate>>>(
    () => [
      {
        id: 'edit',
        label: t('actions.edit'),
        icon: <Pencil aria-hidden />,
        onAction: (rate) => onAction('edit', rate),
      },
      {
        id: 'delete',
        label: t('actions.delete'),
        icon: <Trash2 aria-hidden />,
        variant: 'destructive',
        separatorBefore: true,
        onAction: (rate) => onAction('delete', rate),
      },
    ],
    [onAction, t],
  );
}
